import ErrorModal from './ErrorModal'
import './ErrorModal.css'
export default ErrorModal
